<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      class="cust-header"
      width="30%"
      title="CMS Pages"
      :visible.sync="emailPopup"
    >
      <div class="w-full mx-auto">
        <el-input disabled placeholder="Cms Page" v-model="pageName"></el-input>
        <div class="flex items-center gap-2 mt-6">
          <el-radio-group v-model="radio">
            <el-radio class="radiocolor" :label="true">Active</el-radio>
            <el-radio class="radiocolor" :label="false">InActive</el-radio>
          </el-radio-group>
        </div>
        <div class="flex items-center justify-center">
          <vs-button
            @click="updateUpdages"
            type="success"
            class="bg-success rounded-full mt-6 border-0 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
          >
            Update
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowDetailsAddons" width="50%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Select Layout
        </h3></template
      >
      <div v-if="this.selected_page_data.hasOwnProperty('variation')">
        <div class="grid grid-cols-3 gap-4 mt-4">
          <div class="w-full" v-for="(i, index) in variations" :key="index">
            <div class="rounded-lg hoverborder border" @click="selectVar(i)">
              <div class="p-1 relative">
                <img
                  :src="getImage(i.img)"
                  alt="grid"
                  class="w-full h-200px object-contain rounded-lg"
                />
                <div class="absolute top-0 right-0 m-2">
                  <el-checkbox
                    @click="selectVar(i)"
                    v-model="i.checked"
                    :class="!check ? 'hovcheck' : null"
                  ></el-checkbox>
                </div>
              </div>
              <div class="bg-dedede btm-border py-1 px-2">
                <div class="flex w-full justify-between items-center">
                  <p><b>Title:</b> {{ i.name }}</p>
                  <feather-icon
                    icon="EyeIcon"
                    class="cursor-pointer"
                    svgClasses="w-4 h-4"
                    @click="imagePreview(i.img)"
                  />
                </div>
                <span><b>ID:</b> {{ i.id }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center w-full mt-4">
          <vs-button
            variant="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-4 sm-fsize14"
            @click="addVariation"
          >
            Submit
          </vs-button>
        </div>
      </div>
      <div v-else>
        <p>No data</p>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowDetailsimg" width="35%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Image</h3></template
      >
      <div class="w-full">
        <div class="overflow-auto he-imgpro">
          <img
            :src="this.imgPreviewValue"
            alt="img"
            class="w-full rounded-lg"
          />
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Website Content
          </h2>
        </div>
      </div>
    </div>

    <div class="menucontrol-scroll fixed-top">
      <div class="bg-white relative flex items-center w-full mx-auto mt-4 px-8">
        <div class="relative pr-4 w-full">
          <el-input
            placeholder="Search"
            v-model="inputSearch"
            @onchange="inputSearch"
            class="w-full"
            maxlength="50"
          ></el-input>
          <div
            class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-16px"
          >
            <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
          </div>
        </div>
      </div>
      <div class="py-6 px-8">
        <div class="">
          <el-table
            :data="pages"
            border
            style="width: 100%"
            class="table-responsive"
            header-row-class-name="thead-light table-th-color"
          >
            <el-table-column
              :index="indexmethod"
              type="index"
              label="Sr.no"
              width="80"
            ></el-table-column>
            <el-table-column prop="page" label="Page" min-width="400px">
              <template v-slot="{ row }">
                <P class="text-gray">{{ row.page }}</P>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="CMS" min-width="200px">
              <template v-slot="{ row }">
                <!-- <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="Marcom CMS"
                > -->
                <feather-icon
                  slot="reference"
                  icon="EyeIcon"
                  class="cursor-pointer mr-4"
                  svgClasses="w-6 h-6"
                  @click="openCmsURL(row)"
                />
                <feather-icon
                  slot="reference"
                  icon="EditIcon"
                  class="cursor-pointer"
                  svgClasses="w-6 h-6"
                  @click="editStatusCMS(row)"
                />
                <feather-icon
                  slot="reference"
                  icon="FileIcon"
                  class="cursor-pointer ml-2"
                  svgClasses="w-6 h-6"
                  v-if="row.variation.length"
                  @click="selectedPage(row)"
                />
                <!-- </el-popover> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
import { mapState } from "vuex";

export default {
  data() {
    return {
      tasklist: [],
      pages: [],
      isShowDetailsimg: false,
      isShowDetailsAddons: false,
      selected_page_data: [],
      check: "",
      selectedVar: {},
      variations: [],
      fetchedVariant: {},
      imgPreviewValue: "",
      emailPopup: false,
      radio: false,
      editData: "",
      pageName: "",
      inputSearch: "",
    };
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["login"]),
  },
  methods: {
    editStatusCMS(data) {
      this.emailPopup = true;
      this.editData = data;
      this.pageName = this.editData.page;
      this.radio = this.editData.isActive;
    },
    async updateUpdages() {
      let payload = {
        _id: this.editData._id,
        projectId: this.selectedProject._id,
        isActive: this.radio,
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      };
      const data = await this.$store.dispatch("builder/updatePages", payload);
      if (data.code === 200) {
        this.$swal({
          text: "Page Successfully Updated",
          icon: "success",
          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
        this.getPages();
      }
    },
    async getTasklist() {
      let payload = {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      };

      const { data } = await this.$store.dispatch(
        "builder/getTasklist",
        payload
      );
      this.tasklist = data;
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    getImage(value) {
      if (value) {
        return `${value}`;
      } else {
        return "@/assets/images/icons/Dashboard.svg";
      }
    },
    imagePreview(value) {
      this.imgPreviewValue = value;
      this.isShowDetailsimg = true;
    },

    async getPages() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        // tasklistID: this.tasklist[this.tasklist.length - 1]._id,
        // type: "Website",
      };
      if (this.inputSearch) {
        Object.assign(payload, { searchQuery: this.inputSearch });
      }
      const { data } = await this.$store.dispatch("builder/getPages", payload);

      this.pages = data;
    },

    openCmsURL(value) {
      console.log(value.page);
      window.open(`${process.env.VUE_APP_WEB_URL}${value.page}/123`, "_blank");
    },
    async selectedPage(value) {
      this.isShowDetailsAddons = true;

      this.selected_page_data = value;
      await this.getSelectedVariant();
      if (this.selected_page_data.hasOwnProperty("variation")) {
        this.variations = this.selected_page_data.variation;
        this.variations = this.variations.map((x) => ({
          checked: !!Object.keys(this.fetchedVariant).length
            ? this.fetchedVariant.selectedVariation.id.toString() ===
              x.id.toString()
            : false,
          ...x,
        }));
      }
    },
    async selectVar(value) {
      this.selectedVar = value;

      this.variations.forEach((element) => {
        if (this.selectedVar.id.toString() === element.id.toString()) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    },

    async addVariation() {
      if (!Object.keys(this.fetchedVariant).length) {
        let { data } = await this.$store.dispatch("variation/addVariations", {
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          pageId: this.selected_page_data.pageId,
          pageData: this.selected_page_data,
          selectedVariation: this.selectedVar,
        });

        if (data) {
          this.selectedVar = "";
          this.isShowDetailsAddons = false;
        }
      } else {
        let { data } = await this.$store.dispatch("variation/editVariations", {
          projectName: this.selectedProject.projectName,

          pageId: this.selected_page_data.pageId,

          selectedVariation: this.selectedVar,
        });
        if (data) {
          this.selectedVar = "";
          this.isShowDetailsAddons = false;
        }
      }
    },

    async getSelectedVariant() {
      let payload = {
        projectName: this.selectedProject.projectName,
        pageId: this.selected_page_data.pageId,
      };
      let { data } = await this.$store.dispatch(
        "variation/getVariations",
        payload
      );
      this.fetchedVariant = data;
    },
  },
  watch: {
    emailPopup(value) {
      if (value === false) {
        this.pageName = "";
        this.radio = false;
      }
    },
    inputSearch: debounce(async function (value) {
      this.getPages();
    }),
  },

  async mounted() {
    await this.getTasklist();
    await this.getPages();
  },
};
</script>

<style>
.h-200px {
  height: 200px;
}

.bg-dedede {
  background: #dedede;
}
.hoberborder {
  border: 1px solid #dedede;
}
.hoberborder:hover {
  border: 2px solid rgba(var(--vs-primary)) !important;
}

.btm-border {
  border-radius: 0 0 5px 5px;
}
</style>
